module.exports = __webpack_public_path__ + "img/milad-rahatianpur.7e0c5270.jpg";